import PropTypes from 'prop-types';
import React from 'react';

const DocumentSectionListItem = ({ sectionXpath, sectionNote }) => (
    <tr>
        <td>{sectionXpath}</td>
        <td>{sectionNote}</td>
    </tr>
);

DocumentSectionListItem.propTypes = {
    sectionXpath: PropTypes.string.isRequired,
    sectionNote: PropTypes.string,
};

export { DocumentSectionListItem };
